import React from 'react';
import { ActivityIndicator } from 'antd-mobile'
import { connect } from 'react-redux';
class Loading extends React.Component {

  componentDidMount () {

  }

  render() {
    let {loading} = this.props.loading
    return <div>
      <ActivityIndicator toast animating={loading} size='large' text='加载中...' />
    </div>
  }
}
const mapState =  connect(state => {
  const { loading } = state;
  return {
    loading
  };
});
export default mapState(Loading);
